(function () {
    'use strict';

    angular.module("imApp").factory("docArticleSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1380,
                    parameters: parms || {}
                });
            },
            listDocumentArticles: function (parms) {
                return $ihttp.post({
                    method: 1381,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
